<template>
  <div class="library-result-item-wrap">
    <router-link :to="{
    name: getRouteName,
    params: { id: collectionEntry.data.id },
    query: {searchText: this.$route.query.searchText, filters: this.$route.query.filters }
    }" :event="disableRoute ? '': 'click'" class="library-result-item-url">
      <div class="library-result-item" :class="{'content-approval': isContentApproval}">
        <img class="image" :src="collectionEntry.data.image" @click="disableRoute=false">
        <div class="inner-container">
          <h2 class="title" @click="disableRoute=false">
            <img :src="getIcon(collectionEntry)" :class="{ 'rotate-icon': shouldRotate }"
                 class="icon" alt="icon">
            <span>
              {{ collectionEntry.data.title }}
            </span>
          </h2>
          <template v-if="isContentApproval">
            <div class="text-wrap">
              <p class="text">
                <span v-if="isContributor"> {{ $t('SENT_IN') }}: {{ getEntrySubmitted(collectionEntry).date }}</span>
                <span v-else><i>{{ $t('SENT_BY')}}</i>
                &nbsp;
                <b>{{ getEntrySubmitted(collectionEntry).user }}</b>
                {{ $t('IN') }}
                <b>{{ getEntrySubmitted(collectionEntry).date }}</b></span>
              </p>
              <p class="edited-by" v-if="getLastEntryEventByStatus(collectionEntry)"
              :title="getEditedTitle">
                <i>{{ getEventNameByStatus }}</i>
                <b>{{ getLastEntryEventByStatus(collectionEntry).user }}</b>
                <span>{{ $t('IN') }}</span>
                <b>{{ getLastEntryEventByStatus(collectionEntry).date }}</b>
              </p>
            </div>
            <div class="text-editor" v-if="entryStatus === entryApprovalStatuses.PENDING">
              <span>
                {{ $t('EDITORS') }}:
              </span>
              <span class="bold ellipsis" :data-text="getEntryEditors(collectionEntry)" :class="{ 'text-tooltip': getEntryEditors(collectionEntry) != ''}">
                  {{ getEntryEditors(collectionEntry) }}
                </span>
            </div>
          </template>
          <p v-else class="text" v-html="collectionEntry.data.description"/>
        </div>
      </div>
    </router-link>
    <entry-management-toolbar  v-if="isContentApproval && entryStatus != entryApprovalStatuses.PUBLISHED"
                        :collectionEntry="collectionEntry"/>
  </div>
</template>

<script>
import { getCollectionEntryTypeIcon, shouldRotate } from '@/utilityFunctions'
import { mapGetters, mapState } from 'vuex'
import { entryStatusesEventMap, entryApprovalStatuses, permissionTypes } from '@/constants'
import EntryManagementToolbar from '@/components/entry-management-toolbar'

export default {
  name: 'entry-row',

  components: { EntryManagementToolbar },

  data () {
    return {
      disableRoute: false,
      entryStatusesEventMap,
      entryApprovalStatuses
    }
  },

  props: {
    collectionEntry: {
      type: Object,
      required: true
    }
  },

  mounted () {
    if (this.isContentApproval) {
      // If the state is 'content-approval', disable route,
      // and limit the click area only to the title and the image.
      this.disableRoute = true
    }
  },

  computed: {
    shouldRotate,
    ...mapState({
      userRoles: state => state.base.userRoles
    }),
    isContributor () {
      return this.userRoles?.includes(permissionTypes.CONTRIBUTOR)
    },
    getRouteName () {
      if (this.$route.name.includes('contentApproval')) {
        return 'contentApprovalCollectionEntry'
      } else {
        return 'collectionEntry'
      }
    },
    getEditedTitle () {
      return this.getEventNameByStatus + ' ' + this.getLastEntryEventByStatus(this.collectionEntry).user +
        ' ' + this.$t('IN') + ' ' + this.getLastEntryEventByStatus(this.collectionEntry).date
    },
    isContentApproval () {
      return this.$route.name === 'contentApproval'
    },
    entryStatus () {
      return this.collectionEntry.data.published_status
    },
    getEventNameByStatus () {
      return this.$t(this.entryStatus + '_BY')
    },
    ...mapGetters(['getEntrySubmitted',
      'getEntryEditors', 'getLastEntryEventByStatus'])
  },

  methods: {
    getIcon (collectionEntry) {
      return getCollectionEntryTypeIcon(collectionEntry)
    }
  }
}
</script>

<style scoped>

</style>
